/**
 * Google Analytics 4: same property as public/index.html (single gtag load).
 *
 * "One tag per page" means: do not paste a second copy of the gtag.js snippet.
 * Calling gtag('event', …) is correct and expected; it does not add another tag.
 */

export const GA_MEASUREMENT_ID = 'G-NL33NSS94M';

export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', eventName, params);
}

/** Primary CTA / navigation intent (custom dimensions friendly). */
export function trackCta(ctaId, placement, extra = {}) {
  trackEvent('pycrust_cta', {
    cta_id: ctaId,
    placement,
    ...extra,
  });
}

export function trackEmailClick(placement) {
  trackEvent('contact_email_click', { placement });
}
